module Meevo.Components.Filters {

    export function meevoFeePercentFilter(): any {
        const filter = (input: any): string => {
            let final = "";
            let temp = "";
            let numberTest = /\D/;
            let dollarTest = /\$/;
            let oneDecimalTest = /\d\./;
            let zeroTest = /\.\d{3}/;
            let numberSplit = [];

            input = input.toString();
            if (!input) {
                return input;
            }
            if (!oneDecimalTest.test(input)) {
                final = input + ".000%"
            }
            else {
                var decimalLength = input.length - (input.search(oneDecimalTest) + 2);

                if (!zeroTest.test(input)) {
                    for (decimalLength; decimalLength < 3; decimalLength++) {

                        input = input + "0";
                    }
                }

                if (decimalLength > 3) {
                        input = input.substring(0, input.length - 4);
                }
                final = input+"%";     
            }

            return final;
        }

        return filter;
    }

    angular.module("meevo.components.filters")
        .filter("meevoFeePercent", meevoFeePercentFilter);

}